import React, { type FC, type PropsWithChildren } from 'react';
import { DH } from '../../../utils/DataHook';
import s from './styles.scss';

export const Container: FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <div data-hook={DH.PaymentMethodItem.Affirm} className={s.container}>
      {children}
    </div>
  );
};
